import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import PropTypes from '../../helpers/propTypes';
import usePageAria from '../../hooks/usePageAria';
import Md from '../Md';
import Actions from './Actions';

const useStyles = makeStyles((theme) => {
  const containerPrint = {
    '@media print': {
      width: '100%',
      margin: 'auto',

      '& > .MuiGrid-container': {
        display: 'block',
      },
    },
  };
  return {
    root: {
      overflowY: 'auto',
      minHeight: '100%',

      '@media print': {
        overflowX: 'hidden',
        overflowY: 'hidden',
      },
    },

    container: {
      width: '80%',
      margin: '20px auto',
      ...containerPrint,
    },

    smallContainer: {
      width: '95%',
      margin: '0 auto',
      ...containerPrint,
    },

    content: {
      [theme.breakpoints.down('xs')]: {
        '& > :first-child': {
          marginTop: 0,
        },
      },
    },
  };
});

function Terms({ close, termsAndAgreement }) {
  const aria = usePageAria();

  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <div className={classes.root} {...aria}>
      <div className={small ? classes.smallContainer : classes.container}>
        <Grid container direction="column" spacing={small ? 0 : 2}>
          <Actions close={close} />
          <Grid className={classes.content} item>
            <Md>{termsAndAgreement}</Md>
          </Grid>
          <Actions close={close} />
        </Grid>
      </div>
    </div>
  );
}

Terms.propTypes = {
  close: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  termsAndAgreement: PropTypes.string.isRequired,
};

export default Terms;
